module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAALxJREFUOE+tk1ESwyAIROFkbU7WerLYk9Euo4bZoMlHM5PJaJbnIqBCj5k9RQTvo32hqCLyUdU36zVumBkELxbRukTQANwM7qwBccAkGLZLSIOdOaQDbGWzHYJ72Um3aXa6/tAtyMFhDQBARypmxpv4CeujCgtAhQO2z0XYVLXOLvkK4Be1qhAAWQrdRT995tJTuNM8s94qAGTl8QCuxqmNgyB1cQE4GmnRjXPrbbD+N0zJVJ7GGWONnojaL+61eLgoQu3qAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/question.png
// module id = 1317
// module chunks = 0